import { extensions, customHtml } from '@yola/ws-sdk';
import constants from '../constants/common';
import renderPreview from './render-preview';

const { RUNTIME_RENDERING_ATTRIBUTE } = customHtml.constants;

function initHtmlEmbedElements(rootNode) {
  const { querySelector: selector } = extensions.accessors.getExtensionSettings(constants.slug);
  const elements = Array.from(rootNode.querySelectorAll(selector));

  if (rootNode.matches && rootNode.matches(selector)) {
    elements.push(rootNode);
  }

  const isRuntimeRenderStatus = customHtml.verifiers.isRuntimeRender();

  elements.forEach((element) => {
    const isRuntimeRendering = element.hasAttribute(RUNTIME_RENDERING_ATTRIBUTE);

    if (!isRuntimeRenderStatus || !isRuntimeRendering) {
      renderPreview(element);
    }
  });
}

export default initHtmlEmbedElements;
